import React from "react";
import peugeot from "../assets/images/peugeot2.jpeg";
import citroen from "../assets/images/citroen2.jpeg";
import opel from "../assets/images/opel2.jpeg";
import ds from "../assets/images/ds2.jpeg";
import eurorepar from "../assets/images/eurorepar21.png";
import DSAUTO from "../assets/images/DSAUTO.png"

export const LoginHeader = () => {
  return (
    <div
      className="card shadow-sm"
      style={{
        maxWidth: "475px",
        margin: "0 auto",
        backgroundColor: "#f7f7f7",
      }}
    >
      <div className="card-body text-center">
        <div className="row justify-content-center g-3">
          <div className="col-2 d-flex justify-content-center align-items-center ">
            <div
              style={{
                height: "120px",
                width: "120px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={peugeot}
                alt="Peugeot Logo"
                style={{
                  backgroundColor: "white",
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="col-2 d-flex justify-content-center align-items-center ">
            <div
              style={{
                height: "100px",
                width: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={citroen}
                alt="Citroen Logo"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="col-2 d-flex justify-content-center align-items-center ">
            <div
              style={{
                height: "100px",
                width: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={opel}
                alt="Opel Logo"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="col-3 d-flex justify-content-center align-items-center">
            <div
              style={{
                height: "100px",
                width: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={DSAUTO}
                alt="DS Automobiles Logo"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <div className="col-2 d-flex justify-content-center align-items-center">
            <div
              style={{
                height: "100px",
                width: "100px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={eurorepar}
                alt="Eurorepar Logo"
                style={{
                  maxHeight: "100%",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
 